module.exports = __webpack_public_path__ + "img/3.a9446f76.png";